import athenaConfig from '../../../config';
import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT } from '../../../constants';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import BaseMfaVerifyOieCustomizer from './base';

const { oieEnabled } = athenaConfig;

export default class MfaVerifyQuestionOie extends BaseMfaVerifyOieCustomizer {
  async shouldCustomize() {
    return oieEnabled && [ 'mfa-verify-question' ].includes(this.context?.controller);
  }
  forgifyController() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
    super.forgifyController();
  }
}
